/* eslint-disable no-multi-spaces */
import i18next from "i18next"

// Bike types IDs 
// -------------------------------
const OTHER_TYPES_ID = 999               // Autres types
const RACE_ROAD_ID = 1                   // Course / route / piste / triathlon
const GRAVEL_HIKER_ID = 2                // Gravel / Randonneuse / Cyclo Cross
const ADULT_MTB_ID = 3                   // VTT Adulte
const HYBRID_BIKE_ID = 4                 // VTC
const CITY_BIKE_ID = 5                   // Ville
const CHILD_BIKE_ID = 6                  // Vélo enfant
const FOLDING_BIKE_ID = 7                // Vélo pliable
const CARGO_BIKE_ID = 8                  // Vélo cargo 2 ou 3 roues
const ADULT_TRICYCLE_ID = 9              // Tricycle adulte
const TANDEM_ID = 10                     // Tandem
const RECUMBENT_BIKE_ID = 11             // Vélo couché
const BMX_ID = 12                        // BMX
const PERSONAL_TRANSPORT_DEVICE_ID = 14  // Engin de déplacement personnel (trottinette...)
const TRAILER_ID = 15                    // Remorque
const CARGO_FRONT_LOADER_ID = 16         // Vélo cargo / bi-porteur personne (charge sur châssis à l'avant)
const CARGO_BACK_LOADER_ID = 17          // Vélo cargo / bi-porteur utilitaire (charge sur châssis à l'avant)
const CARGO_TRIKE_BIKE_ID = 18           // Vélo cargo / triporteur et tricycle (2 roues avant ou 2 roues arrière)
const FAT_BIKE_ID = 19                   // Fat bike



export const bikeTypes = [
  { value: OTHER_TYPES_ID, label: "bike:bike_types.other_type" }, // Autres types
  { value: RACE_ROAD_ID, label: "bike:bike_types.race_road" }, // Course / route / piste / triathlon
  { value: GRAVEL_HIKER_ID, label: "bike:bike_types.gravel_hiker_bike" }, // Gravel / Randonneuse / Cyclo Cross
  { value: ADULT_MTB_ID, label: "bike:bike_types.adult_mtb" }, // VTT Adulte
  { value: HYBRID_BIKE_ID, label: "bike:bike_types.hybrid_bike" }, // VTC
  { value: CITY_BIKE_ID, label: "bike:bike_types.city_bike" }, // Ville
  { value: CHILD_BIKE_ID, label: "bike:bike_types.child_bike" }, // Vélo enfant
  { value: FOLDING_BIKE_ID, label: "bike:bike_types.folding_bike" }, // Vélo pliable
  { value: CARGO_BIKE_ID, label: "bike:bike_types.cargo_bike" }, // Vélo cargo 2 ou 3 roues
  { value: ADULT_TRICYCLE_ID, label: "bike:bike_types.adult_tricycle" }, // Tricycle adulte
  { value: TANDEM_ID, label: "bike:bike_types.tandem" }, // Tandem
  { value: RECUMBENT_BIKE_ID, label: "bike:bike_types.recumbent_bike" }, // Vélo couché
  { value: BMX_ID, label: "bike:bike_types.bmx" }, // BMX
  { value: PERSONAL_TRANSPORT_DEVICE_ID, label: "bike:bike_types.personal_transport_device" }, // Engin de déplacement personnel (trottinette...)
  { value: TRAILER_ID, label: "bike:bike_types.trailer" }, // Remorque
  { value: CARGO_FRONT_LOADER_ID, label: "bike:bike_types.cargo_front_loader" }, // Vélo cargo / bi-porteur personne (charge sur châssis à l'avant)
  { value: CARGO_BACK_LOADER_ID, label: "bike:bike_types.cargo_back_loader" }, // Vélo cargo / bi-porteur utilitaire (charge sur châssis à l'avant)
  { value: CARGO_TRIKE_BIKE_ID, label: "bike:bike_types.cargo_trike_bike" }, // Vélo cargo / triporteur et tricycle (2 roues avant ou 2 roues arrière)
  { value: FAT_BIKE_ID, label: "bike:bike_types.fat_bike" } // Fat bike
]

export const getLabelFromBikeId = (bikeId: number) =>
  bikeTypes.find((type) => type.value === bikeId)?.label

export const getIdFromBikeLabel = (bikeLabel: string) => bikeTypes.find((type) => i18next.t(type.label) === bikeLabel)?.value

/** Some bikes from database have no bikeTypeID, only translated label value. We can find the correct translation label key with this method. */
export const getBikeLabelByText = (bikeLabelText: string) => {
  const AVAILABLE_TRANSLATIONS_COUNTRY = ["fr", "de", "en", "es"] // <- List of available language in Obike Store
  return bikeTypes.find((type) => {
    // For using getFixedT method, we need separate namespace and key item from bikeTypes.type property value.
    // Example : bike:bike_types.other_type -> [ bike:bike_types, other_type ]
    const [namespace, key] = type.label.split(".")

    /** Find all translations for this bileType */
    const translations = AVAILABLE_TRANSLATIONS_COUNTRY.map((lng) => {
      const t = i18next.getFixedT(lng, null, namespace) // use only namespace
      return t(key) // find value by key from lng
    })

    /** If bikeLabelText is in translations, the correct bikeType is find ! */
    return translations.includes(bikeLabelText)
  })?.label
}
